import {DrawReference} from '@platform/ui/DrawReference';
import {drawNumber} from '@platform/contracts/drawNumber';
import type {Snapshot} from '@platform/contracts/x';
import {useCopy} from '@platform/ui/config';
import {BottomCta} from './BottomCta';
import {BottomCtaNavigation} from './BottomCtaNavigation';
import {useOwnedCardsMeta} from './useOwnedCardsMeta';

// Both viewers and participants keep the draw while buying quickly; the
// separate catalogue action also exposes their accepted cards for the next draw.
export function NextDrawAction({state,onBuy,onInspect,label,disabled=false,quickDisabled=false}:{state:Snapshot;onBuy:()=>void;onInspect:()=>void;label:string;disabled?:boolean;quickDisabled?:boolean}){
 const t=useCopy();
 const ownedMeta=useOwnedCardsMeta(state,'live')!,personal=ownedMeta.text;
 return <BottomCta className="room-next-action" revealKey={state.drawId} handleLabel={t('flow.nextDrawHeading')} handleDetail={<DrawReference draw={drawNumber(state)}/>} handleMeta={ownedMeta} data-ui="room-next-action">
  <BottomCtaNavigation state={state} onQuick={onBuy} quickLabel={label} onNavigate={onInspect} disabled={disabled} quickDisabled={quickDisabled} navigationLabel={t('room.nextSelectionDraw',{draw:drawNumber(state)})+' · '+t('flow.chooseCard')+' · '+personal}/>
 </BottomCta>;
}

// The fixed action area remains present while the server prepares a new offer.
// Do not show a purchasable draw or a countdown until one actually exists.
export function NextDrawWaiting({drawId}:{drawId:string}){
 const t=useCopy();
 return <BottomCta className="room-next-action" revealKey={drawId} data-ui="room-next-waiting"><p className="next-draw-waiting" role="status">{t('flow.nextPreparing')}</p></BottomCta>;
}
